import React from 'react';
import { token } from '@atlaskit/tokens';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const fontStyle = cssMap({
	tabFooter: {
		marginTop: token('space.400'),
	},
});

export function BoardsTabFooter({
	hasNextPage,
}: {
	hasNextPage: boolean;
}): React.JSX.Element | null {
	const { formatMessage } = useIntl();

	if (!hasNextPage) return null;

	return (
		<Flex justifyContent="center" alignItems="center" gap="space.100" xcss={fontStyle.tabFooter}>
			{formatMessage(messages.linkToBoardsDirectory, {
				a: (chunks: React.ReactNode[]) => (
					<Text weight="medium">
						<Link href="/jira/boards">{chunks}</Link>
					</Text>
				),
			})}
		</Flex>
	);
}
